import React from "react";
import { Percent, Flame, Building2, ChevronLeft } from "lucide-react";
import { useI18n } from "../../i18n";

const TAXES = [
  ["vat", "tax_vat_name", "tax_vat_rate", "tax_vat_desc", Percent, "Value Added Tax (VAT)"],
  ["excise", "tax_excise_name", "tax_excise_rate", "tax_excise_desc", Flame, "Excise Tax"],
  ["rett", "tax_rett_name", "tax_rett_rate", "tax_rett_desc", Building2, "Real Estate Transaction Tax (RETT)"],
];

export function TaxServicesSection({ onOpen }) {
  const { t } = useI18n();
  return (
    <section id="tax-services" className="max-w-7xl mx-auto px-6 py-20" data-testid="tax-services-section">
      <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-start">
        <div className="lg:sticky lg:top-24">
          <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[hsl(217_63%_15%)]">{t("tax_services_title")}</h2>
          <p className="mt-4 text-muted-foreground text-lg leading-relaxed">{t("tax_services_sub")}</p>
        </div>
        <div className="space-y-3">
          {TAXES.map(([slug, nameK, rateK, descK, Icon, en]) => (
            <button key={slug} data-testid={`tax-card-${slug}`} onClick={() => onOpen && onOpen(slug)}
              className="w-full text-start flex items-center gap-4 rounded-xl border border-border bg-card px-5 py-4 hover:border-[hsl(158_64%_28%)] hover:shadow-sm transition-all group">
              <div className="h-11 w-11 rounded-xl bg-[hsl(217_63%_15%)] flex items-center justify-center group-hover:bg-[hsl(158_64%_28%)] transition-colors shrink-0">
                <Icon className="h-5 w-5 text-white" />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="font-display font-bold text-[hsl(217_63%_15%)]">{t(nameK)}</span>
                  <span className="text-[11px] font-bold rounded-full bg-[hsl(158_64%_94%)] text-[hsl(158_64%_26%)] px-2 py-0.5">{t(rateK)}</span>
                </div>
                <p className="text-sm text-muted-foreground mt-0.5 truncate">{t(descK)}</p>
              </div>
              <ChevronLeft className="h-5 w-5 text-muted-foreground shrink-0 group-hover:text-[hsl(158_64%_28%)] rtl:rotate-0 ltr:rotate-180 transition-transform" />
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
